import {
  Brain,
  Check,
  Crown,
  Shield,
  Sparkles,
  Watch,
  Zap,
  type LucideIcon,
} from "lucide-react";

/**
 * Pro features shown on the paywall and /subscription.
 * Order is the product list. Both surfaces must render every key.
 * Wearables is the gated /settings/integrations surface.
 */
export const PRO_FEATURE_KEYS = [
  "plateTalk",
  "foodPhoto",
  "commandMatrix",
  "evidence",
  "neural",
  "mealPlanning",
  "nutrients",
  "languages",
  "wearables",
] as const;

export type ProFeatureKey = (typeof PRO_FEATURE_KEYS)[number];

export const PRO_FEATURE_ICONS: Record<ProFeatureKey, LucideIcon> = {
  plateTalk: Brain,
  foodPhoto: Zap,
  commandMatrix: Sparkles,
  evidence: Shield,
  neural: Crown,
  mealPlanning: Check,
  nutrients: Check,
  languages: Check,
  wearables: Watch,
};

export function proFeatureItems(t: (key: string) => string): Array<{
  key: ProFeatureKey;
  icon: LucideIcon;
  label: string;
}> {
  return PRO_FEATURE_KEYS.map((key) => ({
    key,
    icon: PRO_FEATURE_ICONS[key],
    label: t(`proFeatures.${key}`),
  }));
}
